import axios from "axios";
import { StandardAxiosConfig, getBaseDataURL } from "../../../common";
import { TeamMember } from "../../../../models";
import { DataAPI_Base } from "../base";

export class TeamMembersAPI extends DataAPI_Base<TeamMember> {
	constructor() {
		super("team-members", TeamMember);
	}

	async setPassword(teamMemberId: string, password: string): Promise<TeamMember> {
		const url = `${getBaseDataURL("team-members")}/set-password`;
		const response = await axios.post(url, { team_member_id: teamMemberId, password }, StandardAxiosConfig());
		return response.data as TeamMember;
	}
}
